import React, { useEffect, useMemo, useState } from "react";
// import "./PersonalDetails.css";
import { toast } from "sonner";
import { CustomModal } from "components/modals/ModalBox";
import { MultiSelect } from "components/form";
import { Select } from "common/InputForm";
import { addArticleApi, articleCategoryListApi, articleDetailApi, updateArticleApi } from "services/article";

const formTeething = {
    GUMS: "Gum",
    BITE: "Biting",
}

const ManageActivity = ({ _id, type, onClose, isOpen, getListHandler, propertyTab }) => {
    const isEditable = useMemo(() => type === "EDIT", [type]);
    const [articleCategories, setArticleCategories] = useState([]);
    const [formFields, setFormFields] = useState({
        uploadedImage: null,
        image: "",
        name: "",
        _category: "",
        description: "",
        status: "",
        isFree: false,
        teething: [],
        sleeping: [],
        ageGroup: [],
    });

    const fetchArticleCategoryData = async () => {
        try {
            const { data } = await articleCategoryListApi({});
            if (data?.success) {
                setArticleCategories(data?.data);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const fetchData = async () => {
        try {
            const { data } = await articleDetailApi({ _id });
            if (data?.success) {
                const detail = data?.data;
                setFormFields(prev => ({
                    ...prev,
                    name: detail?.name,
                    description: detail?.description,
                    _category: detail?._category,
                    status: detail?.status,
                    isFree: detail?.isFree,
                    teething: detail?.recommendations?.teething?.map(item => ({ value: item, label: formTeething[item] })),
                    sleeping: detail?.recommendations?.sleeping?.map(item => ({ value: item, label: formTeething[item] })),
                    ageGroup: detail?.ageGroup?.map(item => ({ value: item, label: `${item} Months` })) || [],
                }));
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchArticleCategoryData();
        if (isEditable) {
            fetchData();
        }

        return () => {
            setFormFields({
                uploadedImage: null,
                image: "",
                name: "",
                description: "",
                _category: "",
                isFree: false,
                teething: [],
                sleeping: [],
                ageGroup: [],
            });
        }
    }, [isOpen]);

    // onChangeHandler
    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        if (name === "number") {
            const numericValue = value.replace(/\D/g, "");
            setFormFields({ ...formFields, number: numericValue });
        } else {
            setFormFields({ ...formFields, [name]: value });
        }
    };

    // Error Handler
    const errorHandler = () => {
        let isValid = true;

        if (!formFields?.name) {
            isValid = false;
            toast.error("Please Enter title");
            return;
        }

        if (!formFields?.description) {
            isValid = false;
            toast.error("Please Enter Description");
            return;
        }

        if (!formFields?._category) {
            isValid = false;
            toast.error("Please Select Category");
            return;
        }

        if (!formFields?.ageGroup?.length) {
            isValid = false;
            toast.error("Please Select Age Group");
            return;
        }

        if (!formFields?.uploadedImage && !isEditable) {
            isValid = false;
            toast.error("Please Upload Image");
            return;
        }

        return isValid;
    };

    const createRequest = async (status) => {
        if (errorHandler()) {
            try {
                const formData = new FormData();
                const payload = {
                    ...formFields,
                    language: propertyTab,
                    teething: formFields?.teething?.map(item => item.value),
                    sleeping: formFields?.sleeping?.map(item => item.value),
                    ageGroup: formFields?.ageGroup?.map(item => item.value),
                    image: formFields?.uploadedImage,
                    status: status === "PUBLISH" ? "ACTIVE" : "DRAFT"
                }

                delete payload?.uploadedImage;

                for (const key in payload) {
                    if (key === "teething" || key === "sleeping" || key === "ageGroup") {
                        formData.append(key, JSON.stringify(payload[key]));
                    } else {
                        formData.append(key, payload[key]);
                    }
                }

                const { data } = await addArticleApi(formData);
                if (data?.success) {
                    toast.success(data?.message);
                    onClose();
                    getListHandler();
                } else {
                    toast.error(data?.message);
                }
            } catch (err) {
                console.error(err);
            }
        }
    };

    const updateRequest = async (status) => {
        if (errorHandler()) {
            try {
                const formData = new FormData();
                const payload = {
                    ...formFields,
                    language: propertyTab,
                    teething: formFields?.teething?.map(item => item.value),
                    sleeping: formFields?.sleeping?.map(item => item.value),
                    ageGroup: formFields?.ageGroup?.map(item => item.value),
                    ...(formFields?.uploadedImage && { image: formFields?.uploadedImage }),
                    status: status === "PUBLISH" ? "ACTIVE" : "DRAFT"
                }

                delete payload?.uploadedImage;
                if (payload?.image?.length === 0) {
                    delete payload?.image;
                }

                for (const key in payload) {
                    if (key === "teething" || key === "sleeping" || key === "ageGroup") {
                        formData.append(key, JSON.stringify(payload[key]));
                    } else {
                        formData.append(key, payload[key]);
                    }
                }

                formData.append("_id", _id);
                const { data } = await updateArticleApi(formData);
                if (data?.success) {
                    toast.success(data?.message);
                    onClose();
                    getListHandler();
                } else {
                    toast.error(data?.message);
                }
            } catch (err) {
                console.error(err);
            }
        }
    };

    // onSubmitHandler
    const onSubmitHandler = async (e, status) => {
        e.preventDefault();

        if (type === "CREATE") {
            createRequest(status);
        } else {
            updateRequest(status);
        }
    };

    return (
        <CustomModal className={"lg"} show={isOpen} handleClose={onClose}>
            <div className="personal_details_parents" style={{ padding: 0 }}>
                <div className="personal_form_wrap">
                    <h4>{isEditable ? "Update" : "Create"} Article </h4>

                    <div>
                        {(formFields.status === "DRAFT" || type === "CREATE") && <button
                            className="button"
                            onClick={(e) => onSubmitHandler(e, "PUBLISH")}
                            style={{ marginRight: "10px" }}
                        >
                            Publish
                        </button>}
                        <button
                            className="button"
                            onClick={(e) => onSubmitHandler(e, "DRAFT")}
                        >
                            {isEditable ? "Update" : "Create"}
                        </button>
                    </div>

                </div>

                <form>
                    <div className="form_field_wrap choose_file">


                        <div className="form_field">
                            <label htmlFor="fname" className="label">
                                Image *
                            </label>
                            <input
                                type="file"
                                name="name"
                                className="input"
                                accept="image/*"
                                onChange={e => setFormFields(rev => ({ ...rev, uploadedImage: e.target.files[0] }))}
                            />
                        </div>

                        <div className="form_field">
                            <label htmlFor="fname" className="label">
                                Title *
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="input"
                                onChange={onChangeHandler}
                                value={formFields?.name}
                            />
                        </div>

                        <div className="form_field">
                            <label htmlFor="phn_number" className="label">
                                Category *
                            </label>
                            <Select
                                name="_category"
                                value={formFields?._category}
                                onChange={onChangeHandler}

                            >
                                <option value="" disabled>Select</option>
                                {
                                    articleCategories.map(category => {
                                        return <option value={category?._id} key={category?._id}>{category?.name}</option>
                                    })
                                }
                            </Select>

                        </div>


                    </div>

                    <div className="form_field_wrap">

                        <div className="form_field">
                            <label htmlFor="password" className="label">
                                Description *
                            </label>
                            <textarea
                                name="description"
                                className="input"
                                onChange={onChangeHandler}
                                value={formFields?.description}
                            />
                        </div>


                        <div className="form_field">
                            <MultiSelect
                                label="Age Group *"
                                Options={[
                                    { value: "0-3", label: "0-3 Months" },
                                    { value: "4-6", label: "4-6 Months" },
                                    { value: "7-9", label: "7-9 Months" },
                                    { value: "10-12", label: "10-12 Months" },
                                    { value: "13-15", label: "13-15 Months" },
                                    { value: "16-18", label: "16-18 Months" },
                                    { value: "19-21", label: "19-21 Months" },
                                    { value: "22-24", label: "22-24 Months" }
                                ]}
                                onChange={(e) => setFormFields(rev => ({ ...rev, ageGroup: e }))}
                                value={formFields?.ageGroup}
                            />
                        </div>


                    </div>


                    <h5>Recommendations (Optional)</h5>

                    <div className="form_field_wrap">

                        <div className="form_field">
                            <MultiSelect
                                label="Teething"
                                Options={[
                                    { value: "GUMS", label: "Gum" },
                                    { value: "BITE", label: "Biting" },
                                ]}
                                onChange={(e) => setFormFields(rev => ({ ...rev, teething: e }))}
                                value={formFields?.teething}
                            />
                        </div>


                        <div className="form_field">
                            <MultiSelect
                                label="Sleeping"
                                placeholder="select"
                                Options={[
                                    { value: "GUMS", label: "Gum" },
                                    { value: "BITE", label: "Biting" },
                                ]}
                                onChange={(e) => setFormFields(rev => ({ ...rev, sleeping: e }))}
                                value={formFields?.speech}
                            />
                        </div>
                    </div>

                    <div className="form_field_wrap">
                        <label htmlFor="fname" className="label">
                            Show in free plan
                        </label>
                        <input
                            type="checkbox"
                            name="isFree"
                            className="checkbox"
                            onChange={e => setFormFields((rev) => ({ ...rev, isFree: e.target.checked }))}
                            checked={formFields?.isFree}
                        />
                        <div className="form_field" />
                    </div>

                </form>

                <div className="form_border_bottom"></div>
            </div>
        </CustomModal>
    );
};

export default ManageActivity;
